import {MassCampaignStatusEnum} from '@/services/api-clients';

export function massCampaignStatusColorFilter(status: MassCampaignStatusEnum): string[] {
  switch (status) {
    case MassCampaignStatusEnum.Waiting: return ['primary', 'primary--text'];
    case MassCampaignStatusEnum.Approved: return ['success', 'success--text'];
    case MassCampaignStatusEnum.Pending: return ['warning', 'warning--text'];
    case MassCampaignStatusEnum.Executed: return ['purple', 'purple--text'];
  }
}
